<template>
  <div>
    <h1>Editar destino</h1>
    <div class="card">
      <div class="card-body">
        <a-form :form="form" @submit.prevent="handleSubmit" layout="vertical">
          <div class="row">
            <div class="col-md-6">
              <a-form-item label="Nombre del destino">
                <a-input ref="name" placeholder="Nombre del destino" v-model="$v.destination.name.$model" />
                <small class="text-danger" v-if="!$v.destination.name.required">Campo requerido. No debe estar vacío.</small><br>
                <small class="text-danger" v-if="!validateRegisteredDestination($v.destination.name.$model)">Ya existe un registro con este nombre de destino</small>
              </a-form-item>
            </div>
            <div class="col-12">
              <a-form-item>
                <button ref="button" type="submit" class="btn btn-light px-5" :disabled="!(validateRegisteredDestination($v.destination.name.$model) && !$v.$invalid)">
                  Registrar
                </button>
              </a-form-item>
            </div>
          </div>
        </a-form>
      </div>
    </div>
  </div>
</template>
<script>
import { required } from 'vuelidate/lib/validators'
import gql from 'graphql-tag'
import headers from '@/config/headers.js'
const GET_ALL_DESTINATIONS = gql`
  query getAllDestinations{
    getAllDestinations{
      id
      name
      createdBy
    }
  }
`
const UPDATE_DESTINATION = gql`
  mutation updateDestination($destinationId: Int, $name: String){
    updateDestination(destinationId: $destinationId name: $name ){
      id
      name
    }
  }
`
export default {
  data() {
    return {
      form: this.$form.createForm(this),
      destination: {
        name: this.$route.params.name,
      },
      createdBy: this.$store.state.user.email,
      registeredDestination: {},
    }
  },
  apollo: {
    getAllDestinations: {
      query: GET_ALL_DESTINATIONS,
      context: headers(),
      result({ data }) {
        console.log(data)
        data.getAllDestinations.forEach(destination => {
          this.registeredDestination[destination.name] = 1
        })
        delete this.registeredDestination[this.destination.name]
        // console.log('registered destination')
        // console.log(this.registeredDestination)
      },
      error(error) {
        console.log(error)
      },
    },
  },
  methods: {
    handleSubmit() {
      this.$apollo.mutate({
        mutation: UPDATE_DESTINATION,
        context: headers(),
        variables: {
          destinationId: parseInt(this.$route.params.id),
          name: this.destination.name,
        },
      })
        .then(data => {
          console.log(data)
          this.$router.push({ name: 'getDestinations' })
        })
        .catch(error => {
          console.log(error)
        })
    },
    validateRegisteredDestination(destination) {
      if (this.registeredDestination[destination.trim()]) {
        return false
      } else {
        return true
      }
    },
  },
  created() {
    // console.log(this.$route.params)
  },
  validations: {
    destination: {
      name: { required },
    },
  },
}
</script>
